(function () {
  'use strict';

  var DESKTOP_MQ = '(min-width: 768px)';

  function whenSwiperReady(callback) {
    if (typeof window.Swiper !== 'undefined') {
      callback();
      return;
    }

    var attempts = 0;
    var timer = window.setInterval(function () {
      attempts += 1;
      if (typeof window.Swiper !== 'undefined') {
        window.clearInterval(timer);
        callback();
      } else if (attempts > 40) {
        window.clearInterval(timer);
      }
    }, 50);
  }

  function destroySwiper(root) {
    if (root._accRoReviewsSwiper) {
      root._accRoReviewsSwiper.destroy(true, true);
      root._accRoReviewsSwiper = null;
    }
  }

  function initReviews(root) {
    var track = root.querySelector('[data-acc-ro-reviews-track]');
    var slides = root.querySelectorAll('[data-acc-ro-reviews-slide]');
    var scrollbar = root.querySelector('[data-acc-ro-reviews-scrollbar]');
    var prevBtn = root.querySelector('[data-acc-ro-reviews-prev]');
    var nextBtn = root.querySelector('[data-acc-ro-reviews-next]');
    var dotsWrap = root.querySelector('[data-acc-ro-reviews-dots]');
    var controls = root.querySelector('[data-acc-ro-reviews-controls]');

    if (!track || slides.length === 0 || typeof window.Swiper === 'undefined') return;

    destroySwiper(root);

    if (!track._accRoPreventNativeDrag) {
      track.addEventListener('dragstart', function (event) {
        event.preventDefault();
      });
      track._accRoPreventNativeDrag = true;
    }

    var swiper = new window.Swiper(track, {
      slidesPerView: 1,
      spaceBetween: 16,
      watchOverflow: true,
      simulateTouch: true,
      allowTouchMove: true,
      grabCursor: true,
      touchEventsTarget: 'container',
      touchStartPreventDefault: true,
      preventClicks: true,
      speed: 400,
      navigation: {
        prevEl: prevBtn,
        nextEl: nextBtn
      },
      pagination: {
        el: dotsWrap,
        clickable: true,
        bulletClass: 'ACC_RO_Homepage_19_06_dot',
        bulletActiveClass: 'is-active',
        renderBullet: function (index, className) {
          return (
            '<button type="button" class="' +
            className +
            '" aria-label="Go to review ' +
            (index + 1) +
            '"></button>'
          );
        }
      },
      scrollbar: {
        el: scrollbar,
        draggable: true,
        hide: false,
        dragSize: 'auto',
        snapOnRelease: true
      },
      breakpoints: {
        768: {
          slidesPerView: 'auto',
          spaceBetween: 16,
          freeMode: {
            enabled: true,
            sticky: false
          },
          navigation: {
            enabled: false
          },
          pagination: {
            enabled: false
          },
          scrollbar: {
            el: scrollbar,
            draggable: true,
            hide: false,
            dragSize: 240,
            snapOnRelease: false
          }
        }
      },
      on: {
        init: function () {
          syncChrome(this);
        },
        resize: function () {
          syncChrome(this);
        },
        breakpoint: function () {
          syncChrome(this);
        },
        slideChange: function () {
          syncChrome(this);
        },
        setTranslate: function () {
          syncChrome(this);
        }
      }
    });

    root._accRoReviewsSwiper = swiper;

    function syncChrome(instance) {
      var isDesktop = window.matchMedia(DESKTOP_MQ).matches;

      if (controls) {
        controls.hidden = isDesktop;
      }

      if (scrollbar) {
        scrollbar.hidden = !isDesktop;
        scrollbar.setAttribute('aria-hidden', isDesktop ? 'false' : 'true');
      }

      if (instance && instance.scrollbar && typeof instance.scrollbar.updateSize === 'function') {
        instance.scrollbar.updateSize();
      }
    }
  }

  function initAll() {
    whenSwiperReady(function () {
      var roots = document.querySelectorAll('.ACC_RO_Homepage_19_06[data-acc-ro-reviews]');
      for (var i = 0; i < roots.length; i += 1) {
        initReviews(roots[i]);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target) return;
    var root = event.target.querySelector
      ? event.target.querySelector('.ACC_RO_Homepage_19_06[data-acc-ro-reviews]')
      : null;
    if (root) {
      whenSwiperReady(function () {
        initReviews(root);
      });
    }
  });

  document.addEventListener('shopify:section:unload', function (event) {
    if (!event.target) return;
    var root = event.target.querySelector
      ? event.target.querySelector('.ACC_RO_Homepage_19_06[data-acc-ro-reviews]')
      : null;
    if (root) destroySwiper(root);
  });
})();
